import { jwtDecode } from "jwt-decode";
import { JWT } from "../config/constants";

export function useCurrentUser() {
  const token = localStorage.getItem(JWT.TOKEN_KEY);

  if (!token) {
    return {
      isLoggedIn: false,
      userName: "No User",
      projectName: "No Project",
      isAdmin: false,
    };
  }

  try {
    const decoded = jwtDecode(token);
    return {
      isLoggedIn: true,
      token,
      userId: decoded.user_id,
      userName: localStorage.getItem(JWT.NAMA_KEY) || decoded.nama || "No User",
      projectId: decoded.project_id || localStorage.getItem(JWT.PROJECT_ID_KEY),
      projectName: localStorage.getItem(JWT.PROJECT_NAME_KEY) || "No Project",
      isAdmin: decoded.is_admin === true || decoded.isAdmin === true,
      role: decoded.role || localStorage.getItem(JWT.ROLE_KEY) || "user",
      exp: decoded.exp,
    };
  } catch {
    return { isLoggedIn: false, userName: "No User" };
  }
}
